import BillingComponent from './biling-component/billing-component';
import QuoteDescriptionComponent from './quote-description-component/quote-description-component';
import QuoteNotesComponent from './quote-notes-component/quote-notes-component';
import QuoteHeaderComponent from './quote-header-component/quote-header-component';
import BillingItemsComponent from './billing-items-component/billing-items-component';
import DocumentSignatureComponent from './document-signature-component/document-signature-component';

const components = {
  BillingComponent,
  QuoteDescriptionComponent,
  QuoteNotesComponent,
  QuoteHeaderComponent,
  BillingItemsComponent,
  DocumentSignatureComponent,
};

export default components;
